export default "SELECT *\nfrom USERS u\nJoin Users_Permission up On U.User_Id = up.user_id\nwhere u.USER_ID = 1\n  AND U.Permission_id = 2;\n"